import axios from 'axios';
import { z } from 'zod';

const GeoJSONFeatureSchema = z.object({
	type: z.literal('Feature'),
	id: z.string(),
	properties: z.object({
		maTinh: z.string().optional(),
		tenTinh: z.string(),
		originalName: z.string().optional(),
		name: z.string(),
	}).passthrough(),
	geometry: z.unknown(),
}).strip();

const GeoJSONSchema = z.object({
	type: z.literal('FeatureCollection'),
	features: z.array(GeoJSONFeatureSchema),
}).strip();

export type GeoJSON = z.infer<typeof GeoJSONSchema>;
export type GeoJSONFeature = z.infer<typeof GeoJSONFeatureSchema>;

// Uses bare axios (not apiClient) because these are static files served from Vite's public/ directory, not backend API endpoints
export const geoJsonApi = {
	getNormalizedProvinces: async (): Promise<GeoJSON> => {
		const response = await axios.get('/provinces.normalized.geojson');
		return GeoJSONSchema.parse(response.data);
	},

	getMergedProvinces: async (): Promise<GeoJSON> => {
		const response = await axios.get('/provinces.merged.geojson');
		const features = GeoJSONSchema.parse(response.data).features.map((feature) => {
			// if no maTinh, set maTinh to name
			if (!feature.properties.maTinh) {
				feature.properties.maTinh = feature.properties.name;
			}
			return feature;
		});
		return {
			features,
			...response.data,
		};
	},
};
